// extracted by mini-css-extract-plugin
module.exports = {"inp-field":"inp-field__2o4_G","multi-class":"multi-class__1p58t","input":"input__1fSrL","active":"active__1uYZ9"};